import './SocialUpdatePhotoSource.scss';

import React, {
  ChangeEvent, FC, useCallback, useRef,
} from 'react';
import { Collapse, Fade } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useClickAway } from 'react-use';

interface ISocialUpdatePhotoProps {
  isUpdatePhotoModeOpen: boolean;
  onSetImg: React.Dispatch<React.SetStateAction<Blob | undefined>>;
  onClose: () => void;
}

const SocialUpdatePhotoSource: FC<ISocialUpdatePhotoProps> = ({
  isUpdatePhotoModeOpen,
  onSetImg,
  onClose,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const cameraInputRef = useRef<HTMLInputElement>(null);
  const galleryInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (!file) return;
      onSetImg(file);
    },
    [onSetImg],
  );

  const onTakePhotoClick = useCallback(() => {
    cameraInputRef.current?.click();
  }, []);

  const onChooseFromCameraRoll = useCallback(() => {
    galleryInputRef.current?.click();
  }, []);

  const handleClickAway = useCallback(() => {
    if (!isUpdatePhotoModeOpen) return;
    onClose();
  }, [
    isUpdatePhotoModeOpen,
    onClose,
  ]);

  useClickAway(contentRef, handleClickAway);

  return (
    <div className="social-update-photo-source">
      <Fade in={isUpdatePhotoModeOpen} mountOnEnter unmountOnExit>
        <div className="social-update-photo-source__backdrop" />
      </Fade>
      <Collapse in={isUpdatePhotoModeOpen} dimension="height">
        <div ref={contentRef} className="social-update-photo-source__content">
          <div className="social-update-photo-source__main">
            <h4 className="social-update-photo-source__title">{t('socialSharingModal.updatePhoto')}</h4>
            <button onClick={onTakePhotoClick} type="button" className="btn">
              {t('socialSharingModal.takePhoto')}
            </button>
            <button
              onClick={onChooseFromCameraRoll}
              type="button"
              className="btn"
            >
              {t('socialSharingModal.chooseFromCameraRoll')}
            </button>
          </div>
          <div className="social-update-photo-source__footer">
            <button type="button" onClick={onClose} className="btn">
              {t('socialSharingModal.cancel')}
            </button>
          </div>
          <input
            ref={cameraInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          <input
            ref={galleryInputRef}
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </div>
      </Collapse>
    </div>
  );
};

export default SocialUpdatePhotoSource;
